module.exports = __webpack_public_path__ + "static/media/storage.c7f57601.svg";